import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import { Link, useParams } from "react-router-dom";

import { ScaleLoader } from "react-spinners";
import Loader from "../components/Loader";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper";
import NotFound from "../components/NotFound";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

import {
  FaCloudSun,
  FaCloudversify,
  FaMapMarkedAlt,
  FaNewspaper,
  FaTemperatureHigh,
  FaTruckMonster,
} from "react-icons/fa";
import WeatherApp from "../components/WeatherApp";
import { WEATHER_API_URL, WEATHER_API_KEY } from "../Apis/OpenWeatherApis";
import { MAPBOX_ACCESS_TOKEN } from "../Apis/MapboxApis";
import { Toaster, toast } from "react-hot-toast";
import moment from "moment";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllPostsAction } from "../store/actions/PostActions";
import { CLOUDINARY_URL } from "../services/helper";


const HomePage = ({ lang }) => {
  const [search, setSearch] = useState("");
  const [searchData, setSearchData] = useState(null);
  const [loading2, setLoading2] = useState(false);
  const dispatch = useDispatch();
  const { posts } = useSelector(state => state.FetchAllPostsReducer);
  let { page } = useParams();
  const {loading} = useSelector(state => state.PostReducer);
  
  if(!page)
  {
    page = 1;
  }

  const handleOnSearchSubmit = async (e) => {
    e.preventDefault();
    setSearchData(null);
    setLoading2(true);
    try {
      /*const response1 = await fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${search}.json?language=${lang}&access_token=${MAPBOX_ACCESS_TOKEN}`);
        const data1 = await response1.json();
        const response2 = await fetch(`${WEATHER_API_URL}/weather?lat=${data1.features[0].bbox[1]}&lon=${data1.features[0].bbox[0]}&appid=${WEATHER_API_KEY}`);
        const data2 = await response2.json();
        console.log(data2);*/
      const { data } = await axios.get(
        `${WEATHER_API_URL}/weather?units=metric&q=${search}&appid=${WEATHER_API_KEY}`
      );
      console.log(data);
      if (data) {
        setSearchData(data);
        setLoading2(false);
      } else {
        setSearchData(null);
        setLoading2(false);
      }
    } catch (error) {
      console.log(error);
      toast.error("City not found !");
      setSearchData(null);
      setLoading2(false);
    }
  };
  
  useEffect(() => {
    dispatch(fetchAllPostsAction(page));
    console.log(posts);
  }, []);
  return (
    !loading ?
    <Layout>
      <section className="welcome-section">
        <div className="row">
          <div className="content">
            <div className="icons">
              <img src={ CLOUDINARY_URL + "/c.png"} alt="cloud-rain" />
              <img src={ CLOUDINARY_URL + "/s.png"} alt="cloud-rain" />
              <img src={ CLOUDINARY_URL + "/c-s.png"} alt="cloud-rain" />
              <img src={ CLOUDINARY_URL + "/c-r.png"} alt="cloud-rain" />
              <img src={ CLOUDINARY_URL + "/c-s-r.png"} alt="cloud-rain" />
              <img src={ CLOUDINARY_URL + "/c-t.png"} alt="cloud-rain" />
            </div>
            <h3>
              welcome to
              <span>
                <i className="fas fa-cloud-sun-rain"></i>CP
              </span>
              <span style={{ color: "#710193" }}>WEATHER</span>
              &nbsp;&nbsp;by chaitanya pansare....
            </h3>
            <h1>
              Latest weather information with more feature by introducing{" "}
              <span>AI</span> in our platform..
            </h1>
            <p>
              Local, National & Global daily weather forecast as well as current
              weather information .CP WEATHER provides all things including,
              current weather, weather forecast & history data, current
              temperature of your city with geometric locations with more
              functionality.
            </p>
            <div>
              <Link to="/weather-forecast-search" className="primary-btn">
                <i class="fa fa-bolt me-3"></i>Weather Forecast
              </Link>
              <Link to="#" className="secondary-btn">
                <i class="fa fa-file-image-o me-3"></i>Generate AI Image
              </Link>
            </div>
          </div>

          {/* <div className='images-slider'>
          <img src={png1} alt="" />
          <img src={png2} alt="" />
          <img src={png3} alt="" />
          <img src={png4} alt="" />
       </div> */}

          <div className="images-slider">
            <img src={CLOUDINARY_URL + "/weather-2.png"} alt="" />
          </div>
        </div>
      </section>

      {/* Banner Section starts here */}

      <section className="banner-section">
        <img className="wave" src={CLOUDINARY_URL + "/wave.svg"} alt="" />
        <Toaster
          position="top-center"
          reverseOrder="false"
          toastOptions={{
            style: {
              fontSize: "1.25rem",
              fontWeight: "700",
            },
          }}
        />
        <div className="banner-container">
          <div className="banner-row">
            <div className="banner-col">
              <p>Weather and Forecast</p>
              <h1>Daily Weather</h1>
              <h1>Forecast Update News</h1>
              <div>
                Get the latest weather forecast for today with up-to-date
                information on temperature, precipitation, and more.
              </div>
              <form
                action=""
                className="widget-search-form"
                onSubmit={handleOnSearchSubmit}
              >
                <div className="box">
                  <input
                    type="search"
                    onChange={(e) => setSearch(e.target.value)}
                    value={search}
                    id="search"
                    placeholder="Search for location"
                  />
                  <label
                    htmlFor="search"
                    className="fa fa-search"
                    onClick={handleOnSearchSubmit}
                  ></label>
                </div>
              </form>
              {loading ? (
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    marginTop: "3rem",
                  }}
                >
                  <ScaleLoader color="#010806" />
                </div>
              ) : null}
            </div>

            {searchData === null ? (
              <div className="banner-col">
                <div className="display-container">
                  <div className="name-symbol">
                    <h4 className="name">London</h4>
                    <img
                      src={`${CLOUDINARY_URL}/sun-icon.png`}
                      alt="sun-icon"
                    />
                  </div>
                  <div className="date">Today, 04 April</div>
                  <h1 className="temp">24°</h1>
                  <p className="status">Sunny</p>
                  <div className="wind-speed">
                    <span>Wind</span>
                    <span>19 km/h</span>
                  </div>
                  <div className="humidity">
                    <span>Humidity</span>
                    <span>22%</span>
                  </div>
                </div>
              </div>
            ) : (
              <div className="banner-col">
                <div className="display-container">
                  <div className="name-symbol">
                    <h4 className="name">{searchData.name}</h4>
                    <img
                      src={require(`../icons/${searchData.weather[0].icon}.png`)}
                      alt="sun-icon"
                    />
                  </div>
                  <div className="date">{moment().calendar()}</div>
                  <h1 className="temp">{searchData.main.temp}°</h1>
                  <p className="status">{searchData.weather[0].description}</p>
                  <div className="wind-speed">
                    <span>Wind</span>
                    <span>{searchData.wind.speed} km/h</span>
                  </div>
                  <div className="humidity">
                    <span>Humidity</span>
                    <span>{searchData.main.humidity}%</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Banner Section ends here */}

      {/* Weather Gallery Section */}

      <section className="weather-gallery">
        <div className="section-heading-2 pink">
          <h1 className="main-heading"> Weather in pictures </h1>
          <div className="heading-line">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>
        </div>
        <div className="box-container">
          <Swiper
            breakpoints={{
              0: {
                slidesPerView: 2,
                spaceBetween: 15,
              },
              450: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
              1100: {
                slidesPerView: 4,
                spaceBetween: 20,
              },
            }}
            grabCursor={{
              clickable: true,
            }}
            className="images-slider"
            modules={[Autoplay, Navigation]}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            navigation={true}
          >
            <SwiperSlide>
              <img src={`${CLOUDINARY_URL}/w-g-1.jpg`} alt="" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={`${CLOUDINARY_URL}/w-g-2.jpg`} alt="" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={`${CLOUDINARY_URL}/w-g-3.jpg`} alt="" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={`${CLOUDINARY_URL}/w-g-4.jpg`} alt="" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={`${CLOUDINARY_URL}/weekly-forecast.jpg`} alt="" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={`${CLOUDINARY_URL}/weather-gallery.jpg`} alt="" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={`${CLOUDINARY_URL}/gallery.jpg`} alt="" />
            </SwiperSlide>
          </Swiper>
        </div>
        <Link to={"/weather-gallery"} style={{}} className="secondary-btn">
          Explore now...!
        </Link>
      </section>

      {/* Travel Log Section starts here */}

      <section className="travel-section">
        <div className="section-heading orange">
          <div className="desc">Experience the new</div>
          <div className="main-heading" style={{ color: "white" }}>
            Travel Logging
          </div>
          <div className="heading-line" style={{ color: "white" }}></div>
        </div>

        <div className="travel-container">
          <div className="map">
            <img src={`${CLOUDINARY_URL}/3d.png`} alt="" />
          </div>
          <div className="content">
            <h1>
              <i className="fa fa-map-marker me-2"></i>Add new pin to share your
              experience & get others also !
            </h1>
            <p>
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Aut
              error, porro dolores laudantium similique exercitationem atque
              est? Minima sapiente impedit cum similique.
            </p>
            <Link to={"/travel-log"} className="btn">
              <i class="fa fa-map-pin me-3"></i>Add Your Pin now
            </Link>
          </div>
        </div>
      </section>

      {/* Travel Log Section ends here */}
      
      {/* Blogs Section starts here */}
      
      <section className="blogs-section">
        <div className="section-heading">
            <div className="desc">Share city weather with</div>
            <div className="main-heading">
              Weather Blogs...
            </div>
            <div className="heading-line"></div>
        </div>
        <div className="blogs-box-container">
        {
          posts.length === 0 &&
          <NotFound />
        }
          <Swiper
            breakpoints={{
              0: {
                slidesPerView: 1,
                spaceBetween: 15,
              },
              450: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              1100: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
            }}
            grabCursor={{
              clickable: true,
            }}
            className="images-slider"
            modules={[Autoplay, Navigation]}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            navigation={true}
          >
            {
              posts ?
              posts.map((post, index) => (
                <SwiperSlide key={index}>
                  <div className="box">
                    <div className="picture-container">
                      <img className="picture" src={post.image && post.image} />
                    </div>
                    <div className="content">
                      <div className="time-like">
                        <div className="time"><i class="fa fa-calendar me-2"></i>{moment(post.updatedAt).format("DD/MM/YYYY")}</div>
                        <div className="like"><i class="fa fa-heart-o me-2"></i>like</div>
                      </div>
                      <h1>{post.title}</h1>
                      <p>{post.description}</p>
                      <div className="author">
                        <div className="p-image">
                          <img src={post.user.profilePicture} alt="" />
                        </div>
                        <div className="name-email">
                          <div className="name">{post.user.firstName + " " + post.user.lastName}</div>
                          <div className="email">{post.user.email}</div>
                        </div>
                      </div>
                    </div>
                      <Link className="primary-btn" to={`/details/${post.slug}`}>Read more</Link>
                  </div>
                </SwiperSlide>
              ))
              : null
            }
          </Swiper>
        </div>
      </section>
      
      {/* Blogs Section ends here */}

      {/* Community Section starts here */}

      <section className="community-section">
        <div className="community-section__container">
          <div className="community-section__container__photos">
            <img src={`${CLOUDINARY_URL}/com2.png`} alt="" />
          </div>
          <div className="community-section__container__content">
            <h1>Join our community</h1>
            <p>
              In ut odio libero, at vulputate urna. Nulla tristique mi a massa
              convallis cursus. Nulla eu mi magna. Etiam suscipit commodo
              gravida. Lorem ipsum dolor sit amet, conse ctetuer adipiscing
              elit, sed diam nonu mmy nibh euismod tincidunt ut laoreet dolore
              magna aliquam erat.
            </p>
            <Link
              to={"/register-login"}
              className="secondary-btn"
              style={{
                color: "#D50000",
                textAlign: "center",
                width: "30%",
                background: "white",
                padding: "1.25rem",
                fontWeight: "700",
                marginTop: "2rem",
                boxShadow: "0 0 2rem rgba(213, 0, 0, 0.1)",
              }}
            >
              SIGN IN
            </Link>
          </div>
        </div>
      </section>

      {/* Community Section ends here */}

      {/* Services Section starts here */}

      <section className="services">
        <div className="section-heading">
          <div className="desc">Top Quality</div>
          <div className="main-heading">Services that we Offer</div>
          <div className="heading-line"></div>
        </div>

        <div className="row">
          <div className="col">
            <h1>
              {" "}
              <span>
                <FaCloudSun className="me-1" /> Curr
              </span>
              ent Weather
            </h1>
            <p>
              CPWeather is a company that specializes in providing accurate and
              up-to-date weather information to its customers. They offer a wide
              range of services, including current weather conditions and severe
              weather alerts. Their state-of-the-art technology and team of
              meteorologists allow them to gather and analyze weather data from
              around the globe, providing customers with the most accurate and
              reliable information.
            </p>
          </div>
          <div className="col" align="center">
            <img src={CLOUDINARY_URL + "/services.svg"} alt="current weather" />
          </div>
        </div>

        <div className="row">
          <div className="col">
            <h1>
              {" "}
              <span>
                <FaCloudversify className="me-1" /> wea
              </span>
              ther forecasting
            </h1>
            <p>
              Weather forecasting is the practice of predicting the atmospheric
              conditions, such as temperature, humidity , wind speed, and
              precipitation, for a specific location and time in the future.
              This is done by analyzing data from weather satellites, radar, and
              weather stations, as well as using computer models to simulate the
              behavior of the atmosphere. Accurate weather forecasting is
              important for a variety of activities, such as agriculture,
              transportation, and emergency management.
            </p>
          </div>
          <div className="col" align="center">
            <img src={CLOUDINARY_URL + "/weather-forecast.svg"} alt="current weather" />
          </div>
        </div>

        <div className="row">
          <div className="col">
            <h1>
              {" "}
              <span>
                <FaTruckMonster className="me-1" /> Tra
              </span>
              vel Advisor & Log
            </h1>
            <p>
              A travel advisor and map app is a software that helps users plan
              and navigate their trips. It typically includes features such as
              recommending popular tourist destinations, providing detailed
              information about transportation options, and displaying
              interactive maps. Some apps also offer the ability to book
              accommodations and make reservations for activities, such as tours
              or restaurant reservations. A travel advisor and map app can be a
              useful tool for both leisure and business travelers, as it can
              help them plan and organize their trip, as well as navigate
              unfamiliar destinations
            </p>
          </div>
          <div className="col" align="center">
            <img src={CLOUDINARY_URL + "/travel.svg"} alt="current weather" />
          </div>
        </div>

        <div className="row">
          <div className="col">
            <h1>
              {" "}
              <span>
                <FaTemperatureHigh className="me-1" /> Curr
              </span>
              ent Temperature & Location
            </h1>
            <p>
              Current temperature and location refer to the current weather
              conditions and geographic location of a specific place. The
              current temperature can be measured using thermometers, and can be
              expressed in units such as Celsius or Fahrenheit. Knowing the
              current temperature can be useful for various activities, such as
              dressing appropriately, planning outdoor activities, and adjusting
              energy consumption. The location can be determined using GPS
              technology, which can provide coordinates and other
              location-related information. Knowing your current location can be
              important for navigation, emergency response and many other
              activities.
            </p>
          </div>
          <div className="col" align="center">
            <img src={CLOUDINARY_URL + "/temperature.svg"} alt="current weather" />
          </div>
        </div>

        <div className="row">
          <div className="col">
            <h1>
              {" "}
              <span>
                <FaMapMarkedAlt className="me-1" /> Rea
              </span>
              l time map
            </h1>
            <p>
              Real-time map service is a type of technology that allows users to
              view and interact with maps in real-time. This means that the maps
              are constantly updated with the latest information, such as
              traffic conditions, weather, and location-based points of
              interest. Real-time map services can be accessed through various
              platforms, including web browsers, mobile apps, and in-vehicle
              navigation systems. They are often used for navigation,
              location-based advertising, and other location-based services.
            </p>
          </div>
          <div className="col" align="center">
            <img src={CLOUDINARY_URL + "/map.svg"} alt="current weather" />
          </div>
        </div>
      </section>

      {/* Service Section ends here */}

      {/* News Section */}

      <section className="news-section">
        <div className="section-heading">
          <div className="desc">Track on real time</div>
          <div className="main-heading">News of world</div>
          <div className="heading-line"></div>
        </div>

        <div className="box">
          <div className="image-container">
            <img src={CLOUDINARY_URL + "/news-section.svg"} alt="news" />
          </div>
          <div className="content">
            <h1>
              {" "}
              <i className="fas fa-newspaper me-2"></i> Flexible Live News
              Experience...
            </h1>
            <p>
              News is information about recent events, happenings, and
              developments in various fields such as politics, business, sports,
              entertainment, and more. It is widely distributed through various
              mediums such as newspapers, television, radio, and the internet.
              News is typically organized into various categories, such as
              national news, international news, sports news, entertainment
              news, etc., to make it easier for audiences to find news that is
              relevant to their interests.
            </p>
            <Link to={"/news"} className="primary-btn">
              Take a look now !
            </Link>
            <Link to={""} className="secondary-btn">
              About API
            </Link>
          </div>
        </div>
      </section>

      {/* Weather App Section */}
    </Layout> : <Loader />
  );
};

export default HomePage;
